import { Link } from "react-router-dom";

const columns = [
  {
    title: "业务端口",
    links: [
      { label: "农场种植管理", to: "/farm" },
      { label: "农场认种", to: "/adopt" },
      { label: "智慧认种", to: "/smart-adopt" },
      { label: "农场体验", to: "/experience" },
      { label: "农文旅专题", to: "/feature" },
      { label: "智慧农场解决方案", to: "/solution" },
      { label: "圈层社交", to: "/community" },
      { label: "社区交友圈子", to: "/circle" },
      { label: "美食街种植基地", to: "/food-street" },
      { label: "用户工作台", to: "/portal" },
      { label: "城市田园改造", to: "/urban" },
    ],
  },
  {
    title: "主题农场",
    links: [
      { label: "同乡园", to: "/circle" },
      { label: "宗亲园", to: "/circle" },
      { label: "情侣园", to: "/circle" },
      { label: "商会园", to: "/circle" },
      { label: "协会园", to: "/circle" },
      { label: "兴趣园", to: "/circle" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { label: "三明农链工程", to: "/feature" },
      { label: "仙境景观", to: "/feature" },
      { label: "乡村振兴成果", to: "/feature" },
      { label: "社会帮扶故事", to: "/feature" },
      { label: "原生建造美学", to: "/feature" },
    ],
  },
];

const socials = ["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-youtube-line"];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-leaf-fill text-xl text-white"></i>
              </span>
              <span className="font-heading text-lg font-semibold whitespace-nowrap">
                味聚华夏农耕酵素农场
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              预订单众筹认种农业 · 城乡双向田园重构 · 农文旅社交 · 城市迷你植物森林，以人与人、组织与组织关系为核心的产业共生平台。
            </p>
            <div className="flex gap-3 mt-5">
              {socials.map((icon) => (
                <a
                  key={icon}
                  href="#home"
                  className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-background-100`}></i>
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{col.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © 2026 味聚华夏农耕酵素农场 · 工程代号：三明农链工程 · 保留所有权利
          </p>
          <div className="flex gap-5">
            <a href="#home" className="text-xs text-background-300 hover:text-accent-400 cursor-pointer">
              隐私政策
            </a>
            <a href="#home" className="text-xs text-background-300 hover:text-accent-400 cursor-pointer">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}